import { render, staticRenderFns } from "./LoginBusinessReplace.vue?vue&type=template&id=bb3502a8&scoped=true&"
import script from "./LoginBusinessReplace.vue?vue&type=script&lang=js&"
export * from "./LoginBusinessReplace.vue?vue&type=script&lang=js&"
import style0 from "./LoginBusinessReplace.vue?vue&type=style&index=0&id=bb3502a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3502a8",
  null
  
)

export default component.exports